/**
 * Release provenance for the browser build. `__APP_VERSION__` (short commit
 * SHA), `__COMMIT_HASH__` (full SHA), and `__BUILD_TIME__` are string literals
 * substituted at build time by Vite's `define` (see vite.config.ts).
 * Publishing them on `window.__HEALTHOS__` gives anyone with devtools open a
 * single place to read which commit and build a released tab is running.
 */
export interface HealthOSBuildInfo {
  version: string;
  commit: string;
  releaseTime: string;
}

declare global {
  interface Window {
    __HEALTHOS__?: HealthOSBuildInfo;
  }
}

export const buildInfo: HealthOSBuildInfo = {
  version: __APP_VERSION__,
  commit: __COMMIT_HASH__,
  releaseTime: __BUILD_TIME__,
};

export function publishBuildInfo(): void {
  if (typeof window === "undefined") return;
  window.__HEALTHOS__ = buildInfo;
}
